import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { CustomerLegalForm } from '../model/customer-legal-form';

@Injectable({
    providedIn: 'root'
  })
  export class CustomerLegalFormService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllLegalForms() 
    {
      return this._restClientService.load<CustomerLegalForm[]>('customer-legal-form/customer-legal-forms');
    }
    
    add(legalForm) {
      return  this._restClientService.save<CustomerLegalForm>('customer-legal-form/add-customer-legal-form', legalForm);
    }
    
    update(legalForm) {
      return  this._restClientService.put<CustomerLegalForm>(`customer-legal-form/update-customer-legal-form`, legalForm);
    }
  
    getCustomerLegalFormById(legalFormId)
    {
      return this._restClientService.load<CustomerLegalForm>('customer-legal-form/customer-legal-form-by-id/'+legalFormId);
    }
  
  
  
}      

    